import React from "react";
import "./about.css";

export default function About() {
  return (
    <div className="about-root">

      <h1 className="about-title">About HilalUp</h1>

      <p className="about-text1">
        HilalUp is India’s homegrown refreshing drink crafted with purity, taste,
        and trust. We believe in beverages that not only taste great but are 
        made with the right intention — <strong>“Taste bhi halal, niyat bhi nek.”</strong>
      </p>

      <h2 className="section-heading">Current Available Flavour</h2>

      <div className="flavour-card">
        <h3>🍃 Jeera (Zesty Jeera Masala)</h3>
        <p>
          Our first launch — a perfect blend of bold jeera, Indian spices,
          and natural refreshment. Clean, fizzy, and made with halal-certified ingredients.
        </p>
      </div>

      <h2 className="section-heading">New Flavours Coming Soon!</h2>

      <ul className="coming-list">
        <li>🍋 Lemon Masala</li>
        <li>🥤 Cola Classic</li>
        <li>🍊 Orange Pop</li>
        <li>🥭 Mango Splash</li>
        <li>✨ And many more…</li>
      </ul>

      <p className="about-text">
        Every new flavour is being crafted with care — keeping purity, taste, 
        and Indian tradition at the heart of HilalUp.
      </p>

    </div>
  );
}
